import DatePicker from './date-picker.vue'
export type { DatePickerProps } from './props'
export default DatePicker